import classNames from 'classnames';
import React from 'react';

import { LevelCardStatus } from '../models/LevelsPageLevel';
import { Button } from './Button';
import { Tag } from './Tag';

export interface LevelCardProps {
  title?: string;
  buttonText?: string;
  status: LevelCardStatus;
  size?: 'md' | 'sm';
  imgSrc?: string;
  onClick?: () => void;
  buttonHref?: string;
  exampleBg?: boolean;
}

export const LevelCard: React.FC<LevelCardProps> = ({
  title,
  buttonText,
  status,
  size,
  imgSrc,
  onClick,
  buttonHref,
  exampleBg,
}) => {
  const StatusTag = () => {
    if (status === 'blocked') {
      return <Tag icon="lock" shape="vertical-badge" variant="black-medium" />;
    }
    if (status === 'done') {
      return <Tag icon="check" shape="vertical-badge" variant="green-main" />;
    }
    return <></>;
  };

  const Title = () => {
    if (status !== 'current') {
      return <h1 className="oejr-level-card-title">{title}</h1>;
    }
    return <Tag shape="vertical-flag">{title}</Tag>;
  };

  const CurrentButton = () => {
    if (!buttonText || (status !== 'current' && status !== 'done')) {
      return null;
    }
    return (
      <div className="oejr-level-card-button-wrapper">
        <Button
          icon="arrow-right"
          label={buttonText}
          onClick={onClick}
          href={buttonHref}
          variant="primary"
          size={size !== 'md' ? size : undefined}
        />
      </div>
    );
  };

  const Image = () => {
    if (!imgSrc) {
      return null;
    }
    return <img src={imgSrc} alt={title} />;
  };

  return (
    <div className="oejr-level-card-svg-adapter">
      <div
        className={classNames(
          'oejr-level-card',
          `oejr-level-card-${status}`,
          `oejr-level-card-${size}`,
          exampleBg && `oejr-level-card-example-bg`,
        )}
      >
        <StatusTag />
        <div className="oejr-level-card-title-wrapper">
          <Title />
        </div>
        <div className="oejr-level-card-img">
          <Image />
        </div>
        <CurrentButton />
      </div>
    </div>
  );
};
